import { render, staticRenderFns } from "./ImageUpload.vue?vue&type=template&id=8887df2c&scoped=true"
import script from "./ImageUpload.vue?vue&type=script&lang=ts"
export * from "./ImageUpload.vue?vue&type=script&lang=ts"
import style0 from "./ImageUpload.vue?vue&type=style&index=0&id=8887df2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8887df2c",
  null
  
)

export default component.exports